export default "__VITE_ASSET__DZKTFLin__"